import { render, staticRenderFns } from "./area_ksdyzz.vue?vue&type=template&id=6fd57bcb&scoped=true"
import script from "./area_ksdyzz.vue?vue&type=script&lang=js"
export * from "./area_ksdyzz.vue?vue&type=script&lang=js"
import style0 from "./area_ksdyzz.vue?vue&type=style&index=0&id=6fd57bcb&prod&lang=less"
import style1 from "./area_ksdyzz.vue?vue&type=style&index=1&id=6fd57bcb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fd57bcb",
  null
  
)

export default component.exports